export type CommentType = 'normal' | 'warning' | 'important';

export interface JalBookingInventoryCommentArgs {
  id: number;
  inventory_pair_id: number;
  content: string;
  commented_by_id: number;
  commented_by_name: string;
  commented_at: string;
  status: CommentType;
  created_at: string;
  updated_at: string;
}

export class JalBookingInventoryComment {
  id: number;

  inventoryPairId: number;

  content: string;

  commentedById: number;

  commentedByName: string;

  commentedAt: string;

  status: CommentType;

  createdAt: string;

  updatedAt: string;

  constructor(args: JalBookingInventoryCommentArgs) {
    this.id = args.id;
    this.inventoryPairId = args.inventory_pair_id;
    this.content = args.content;
    this.commentedById = args.commented_by_id;
    this.commentedByName = args.commented_by_name;
    this.commentedAt = args.commented_at;
    this.status = args.status;
    this.createdAt = args.created_at;
    this.updatedAt = args.updated_at;
  }
}

export const commentTypeLabels: Record<CommentType, string> = {
  normal: '通常',
  warning: '要確認',
  important: '重要'
};
